import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '@coworkrz/auth/data-access';
import { User } from '@coworkrz/users/types';
import { forkJoin, of } from 'rxjs';

export const appResolver: ResolveFn<(User | null)[]> = () => {
  const auth = inject(AuthService);
  const observables = [auth.isAuthenticated() ? auth.loadUser() : of(null)];

  return forkJoin(observables);
};
